import { isEmpty, isNil } from 'ramda'

export const isSomething = <T = any>(anything: T): boolean => !isNil(anything) && !isEmpty(anything)
